import { render, staticRenderFns } from "./CafePertumbuhan.vue?vue&type=template&id=13ff1066"
import script from "./CafePertumbuhan.vue?vue&type=script&lang=js"
export * from "./CafePertumbuhan.vue?vue&type=script&lang=js"
import style0 from "./CafePertumbuhan.vue?vue&type=style&index=0&id=13ff1066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports